import { Component, HostListener, OnInit } from '@angular/core';

import { FieldType } from '@ngx-formly/core';

import { AuditService } from '@services/audit.service';

const TAG = 'TaTextareaComponent';

@Component({
    selector: 'app-ta-textarea',
    templateUrl: 'ta-textarea.html',
    styleUrls: ['ta-textarea.scss'],
    standalone: false
})
export class TaTextareaComponent extends FieldType implements OnInit {

    private path: string;
    private updatedKey: string;

    constructor(
        private auditService: AuditService
    ) {
        super();
    }

    @HostListener('ionChange')
    public ionChange() {
        this.textAreaChanges();
    }

    ngOnInit() {
        // Get the path of the field by removing ".value" from the field's key
        this.updatedKey = this.key as string;
        if (this.field.parent?.key && this.field.parent?.parent.key) {
            this.updatedKey = this.field.parent?.parent.key + '[' + this.field.parent?.key + '].' + this.key;
        }

        this.path = (this.updatedKey as string).substring(0, (this.updatedKey as string).lastIndexOf('.'));
    }

    public clear() {
        // The formControl.reset triggers an ionChange event with a null formControl.value
        this.formControl.reset(null);
    }

    private textAreaChanges() {
        if (this.formControl.value) {
            this.auditService.setLocationAndTimestamp(this.updatedKey);
        } else if (this.formControl.value) {
            this.auditService.unsetLocationAndTimestamp(this.updatedKey);
        }
    }
}
